export default __webpack_public_path__ + "static/media/tep_icon_facebook.1ccc5192.svg";